<template>
  <span :class="['internal-amount', { 'internal-amount--compact': compact }]">
    <span>{{ formattedAmount }}</span>
    <img
      v-if="internalCurrency && internalCurrency.image"
      :src="internalCurrency.image"
      :alt="internalCurrency.name || 'Coin'"
      class="internal-amount__icon"
    />
    <span v-else class="internal-amount__symbol">{{ internalLabel }}</span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InternalAmount',
  props: {
    amount: {
      type: [Number, String],
      default: 0
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('app', ['internalCurrency']),
    formattedAmount() {
      return Number(this.amount || 0).toFixed(2)
    },
    internalLabel() {
      return this.internalCurrency?.symbol || this.internalCurrency?.name || 'COIN'
    }
  }
}
</script>

<style scoped>
.internal-amount {
  --internal-amount-icon-size: 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: var(--internal-amount-icon-size);
  white-space: nowrap;
  vertical-align: middle;
}

.internal-amount > span {
  line-height: var(--internal-amount-icon-size);
}

.internal-amount__icon {
  width: var(--internal-amount-icon-size);
  height: var(--internal-amount-icon-size);
  object-fit: contain;
  display: block;
  flex: 0 0 auto;
}

.internal-amount__symbol {
  font-size: 0.95em;
}

.internal-amount--compact {
  --internal-amount-icon-size: 15px;
  gap: 2px;
}
</style>
